import _ from 'underscore';

import { ILocationInfo } from '~src/personalSpace/model/ILocationInfo';
import { IPredictiveModelDetailInfo, IPredictiveModelInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';
import { IPredictiveModel, IPredictiveModelDetail } from '~src/predictiveModel/serverApi/types/IPredictiveModel';
import { IPredictiveModelUsageInfo } from '~src/spacesPlatform/models/IUsageInfo';
import { ContentMapper } from '~src/spacesPlatform/models/mappers/ContentMapper';
import { MapperHelper } from '~src/spacesPlatform/models/mappers/MapperHelper';
import { IUserInfo } from '~src/userManagement/users/models/IUserInfo';
import { UserMapper } from '~src/userManagement/users/models/mappers/UserMapper';


export module PredictiveModelMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: IPredictiveModel[],
    users: _.Dictionary<IUserInfo>,
    locations: ILocationInfo[] = [],
    favoritePredictiveModels: _.Dictionary<any> = {},
  ): IPredictiveModelInfo[] {
    const predictiveModelsToLocation = ContentMapper.getContentToLocationMap(ContentMapper.ContentTypeToTargetMap.predictiveModel, locations);
    return serverApiMetrics.map((m: IPredictiveModel) => {
      return mapOne(m, users[m.ownerId], predictiveModelsToLocation[m.id], !!favoritePredictiveModels[m.id]);
    });
  }

  export function mapOne(
    predictiveModel: IPredictiveModel,
    owner?: IUserInfo,
    location?: ILocationInfo,
    favorite?: boolean,
    usageInfoMaxValues?: IPredictiveModelUsageInfo,
  ): IPredictiveModelInfo {
    return {
      favorite: favorite,
      id: predictiveModel.id,
      luid: predictiveModel.luid,
      name: predictiveModel.name,
      owner: UserMapper.mapOne(owner),
      createdAt: M.toDate(predictiveModel.createdAt),
      updatedAt: M.toDate(predictiveModel.updatedAt),
      contentType: 'predictiveModel',
      usageInfo: <IPredictiveModelUsageInfo>{favoritesTotal: 0},
      usageInfoMaxValues: <IPredictiveModelUsageInfo>{},
      location: location,
    };
  }

  export function mapDetail(p: IPredictiveModelDetail): IPredictiveModelDetailInfo {
    return {
      favorite: p.favorite,
      id: p.id,
      luid: p.luid,
      name: p.name,
      owner: UserMapper.mapOne(p.owner),
      createdAt: M.toDate(p.createdAt),
      updatedAt: M.toDate(p.updatedAt),
      contentType: 'predictiveModel',
      activeVersion: p.activeVersion,
      container: p.container,
    };
  }

  export function mapFromCRASS(content: any): IPredictiveModelInfo {
    return {
      ...content,
    id: content.id,
    contentType: 'predictiveModel',
    name: content.title,
    tags: [],
    owner: UserMapper.mapOneOwnerFromCRASS(content),
    updatedAt: M.toDate(content.modifiedTime) || M.toDateFromTimeOffsetObject(content.modifiedTime),
    };
  }
}
